// Constants for the contact form

export const child = "Barn";
export const Complain = "Klage";
export const website = "Forbedring af siden";
export const Question = "Andre Spørgsmål";
export const alertMessage = 'Venligst Vælg en dato får levering før du kan fortsætte!!';
export const menuMessage = 'Please select a meal before proceeding!!';
